export default __webpack_public_path__ + "static/media/img-soon-8.3c84a925.svg";